
import type { IBanner } from '../models/banner';
import type { ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import { ProductActionType } from '@/shared/apollo-api/__generated__/types';

type ProductAction = NonNullable<ProductPageQuery['productPage']['actions']>[0];

const isMotivation = (action: ProductAction): action is Extract<ProductAction, { __typename?: 'MotivationAction' }> =>
  action.type === ProductActionType.Motivation;
const isWishSale = (action: ProductAction): action is Extract<ProductAction, { __typename?: 'WishSaleAction' }> =>
  action.type === ProductActionType.WishSale;

/**
 * Функция преобразует баннеры продукта. Проблема в том, что с бэкенда приходит svg xml разметка.
 * @param {Product.IProductAction[]} actions - Список банеров.
 * @return {IBanner[]} Список преобразованных банеров.
 */
export function actionsToBanners(actions: ProductAction[]): IBanner[] {
  return actions.map((action) => {
    if (isMotivation(action)) {
      return {
        icon: action.image.low,
        label: action.text,
        backgroundColor: '#FFF9D1',
      };
    } else if (isWishSale(action)) {
      return {
        icon: '',
        label: action.type,
        backgroundColor: '#FFF9D1',
      };
    }
    return null;
  }).filter((banner) => banner !== null) as IBanner[];
}
